import React from 'react';
import {Carousel} from '../Home';

const Campaign = () => {
 return(
    <div className="common__item">
     <div className="common__center">
      <h2>開催中のキャンペーン</h2>
      <Carousel />
    </div>
   </div>
 )
}

export default Campaign;
